import React from "react";
import '../../assets/css/buttons/GreenButton.css';


const GreenButton = ({setTrue, setFalseArr, fancyBorder=true, onClickDo, children}) => {
    const doSets = () => {
        console.log("doing sets");
        
        if(setTrue) {
            setTrue(true);  
        }
        
        if(setFalseArr && Array.isArray(setFalseArr)) {
            setFalseArr.forEach(setFalse => {
                setFalse(false);
            });
        }
    }

    return (
        <button 
            className={"flex flexCenter bigGreenButton " + (fancyBorder ? "fancyGreenBorder" : "regularGreenBorder")} 
            type="button" 
            onClick={(e) => {
                if(onClickDo) {
                    onClickDo(e);
                }
                doSets();
            }}
        >
            {children}
        </button>
    );
}

export default GreenButton;